export const generatePathnames = (
  pathname: string,
  titleItemsLength: number,
): string[] => {
  const pathSegments = pathname.split('/');
  const pathnames = pathSegments.reduce(
    (acc: string[], _, i) => [...acc, pathSegments.slice(0, i + 1).join('/')],
    [],
  );

  return pathnames.slice(pathnames.length - titleItemsLength);
};
